import { render, staticRenderFns } from "./MyDonationForm.vue?vue&type=template&id=7f2e1e08&"
import script from "./MyDonationForm.vue?vue&type=script&lang=js&"
export * from "./MyDonationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports